import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './FloorPlanSidebar.css';

function FloorPlanSidebar({ tables, placingTable, onTableSelect, collapsed, onToggleCollapse }) {
  const { t } = useTranslation();

  // Tables without position
  const unplacedTables = tables
    .filter((table) => table.positionX == null || table.positionY == null)
    .sort((a, b) => {
      const numA = parseInt(a.tableNumber, 10) || 0;
      const numB = parseInt(b.tableNumber, 10) || 0;
      return numA - numB;
    });

  return (
    <div className={`fp-sidebar ${collapsed ? 'fp-sidebar--collapsed' : ''}`}>
      <button
        type="button"
        className="fp-sidebar-toggle"
        onClick={onToggleCollapse}
        aria-expanded={!collapsed}
        aria-controls="fp-sidebar-content"
      >
        <h4 className="fp-sidebar-title">
          {t('tables.unpositioned', 'Sin ubicar')}
          {unplacedTables.length > 0 && ` (${unplacedTables.length})`}
        </h4>
        {collapsed ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
      </button>

      {!collapsed && (
        <div id="fp-sidebar-content">
          {unplacedTables.length === 0 ? (
            <p className="fp-sidebar-empty">{t('tables.allPlaced', 'Todas las mesas ubicadas')}</p>
          ) : (
            <>
              <div className="fp-sidebar-list">
                {unplacedTables.map((table) => (
                  <button
                    type="button"
                    key={table.tableNumber}
                    className={`fp-sidebar-item ${placingTable?.tableNumber === table.tableNumber ? 'fp-sidebar-item--active' : ''}`}
                    onClick={() => onTableSelect(table)}
                  >
                    <span className="fp-sidebar-item-number">
                      {t('tables.table')} {table.tableNumber}
                    </span>
                    <span className="fp-sidebar-item-seats">{table.seats}p</span>
                  </button>
                ))}
              </div>
              {placingTable && (
                <p className="fp-sidebar-hint">
                  {t('tables.clickToPlace', 'Clic en el plano para ubicar')}
                </p>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default FloorPlanSidebar;
